import type { FC } from 'react'

import { Flex } from 'antd'

import McmLink from '@web/shared/components/mcm-link/mcm-link'
import TextInfo from '@web/shared/components/text-info/text-info'
import { AppRoute, ConditionRoute } from '@web/shared/constants/routes.constant'

export const NotAccess: FC = () => (
  <Flex
    vertical={true}
    justify='center'
    style={{ height: '100vh', width: '100%' }}
    align={'center'}
    gap={6}
  >
    <TextInfo style={{ flex: 0 }}>403 | Доступ запрещён</TextInfo>
    <McmLink to={`/${AppRoute.Condition}/${ConditionRoute.Results}`}>
      Вернуться на начальную страницу
    </McmLink>
  </Flex>
)
